const DOCTOR_PRICE_STATUS = {
	WAITING: "waiting",
	APPROVED: "approved",
	REJECTED: "rejected",
};

export default DOCTOR_PRICE_STATUS;
